import cn from "classnames";
import { LoaderProps } from "./types";
import styles from "./styles.scss";

export const Loader = ({ dataTestId, className }: LoaderProps) => (
  <div className={cn(styles.loader, className)} data-test-id={dataTestId}>
    <label>●</label>
    <label>●</label>
    <label>●</label>
    <label>●</label>
    <label>●</label>
    <label>●</label>
  </div>
);
